import React from "react";
import {Box, Button, Container, Header, Link, Modal} from "@amzn/awsui-components-react";
import {JEWorksheet} from "src/models/je-allocation/JEWorksheetList";
import CONSTANTS from "src/utils/constants";

export default function LinkedJEWorksheetModal(props: {visible: boolean,
    onClose: () => void,
    linkedWorksheets: JEWorksheet[] }) {

    const { visible, onClose, linkedWorksheets } = props;

    return <Modal data-class="jeLinkedWorksheetModal" visible={visible}
                  header="Linked Worksheets"
                  size="medium"
                  onDismiss={onClose}
                  footer={
                      <Box float="right">
                          <Button variant="link" className="cancelButton" onClick={onClose}>Cancel</Button>
                      </Box>
                  }>
        <Container
            header={
                <Header variant="h3">
                    <span style={{ fontSize: 'medium'}}>
                        Below are the worksheets linked to the template:
                    </span>
                </Header>
        }
        >
            <div>
                {linkedWorksheets.map((linkedWorksheet) => (
                    <div key={linkedWorksheet.worksheetId} className="jeLinkedWorksheetItem" >
                        <Link href={CONSTANTS.PAGE_NAV.JE_ALLOCATION_LINKED.URL + '/' + window.btoa(linkedWorksheet.worksheetId)}>
                            {linkedWorksheet.worksheetName}
                        </Link>
                    </div>
                ))}
            </div>
        </Container>
    </Modal>
}
